module.exports = __webpack_public_path__ + "static/img/sqair_carbon.46140a5.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/purifiers/sqair_carbon.jpg
// module id = DGWI
// module chunks = 1